/**
 * Generated bundle index. Do not edit.
 */

export * from './transition-patch-public-api';
